import { render, staticRenderFns } from "./Layanan.vue?vue&type=template&id=04f74f5f&"
import script from "./Layanan.vue?vue&type=script&lang=js&"
export * from "./Layanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports